<template>
  <div id="app">
    <div class="timer-box" id="timer-box">
      <div class="container" id="container">
        <p5c ref="sketch" :sketch="sketchScript" :data="data" :key="animationType"></p5c>
      </div>
      <footer>

      <a href="https://mindfuldevmag.com/" target="_blank">
        <img
          src="@/assets/logo-white-small-space.png"
          alt="mindfuldevmag logo"
        />
      </a>
      &rarr;
      <a href="https://mindfuldevmag.com/products" target="_blank">More Tools</a
      >&nbsp;
      <br />
        <small>
          <a href="/impressum" target="_blank" rel="nofollow">Imprint</a> -
          <a href="/datenschutz" target="_blank" rel="nofollow"
            >Privacy Policy</a
          >
        </small>
      </footer>
    </div>

<sidebar v-on:animation-changed="changedAnimation" v-on:sound-changed="changedSound" text="4-7-8 breathing meditation. Do the breathing exercise as long as you wish. 4s breathe in, 7s hold, 8s breathe out" :showAnimationList="true" :showSoundSelection="true"/>
    
  </div>
</template>

<script>
import p5c from "@/components/p5component.vue";
import sidebar from "@/components/sidebar.vue";

import * as defaultAnim from "./sketches/424-app"
import * as c3Anim from "./sketches/3circles"
export default {
  name: "App",
  components: {
    p5c,
    sidebar
  },
  data: function () {
    return {
      animationType: 0,
      // for p5
      data: {
        breatheInTime: 4,
        holdTime: 7,
        breatheOutTime: 8,
        playSound: false
      },
    };
  },
  computed: {
    sketchScript: function () {
      if (this.animationType === 1) {
        return c3Anim.sketch;
      }
      return defaultAnim.sketch;
    },
  },
  mounted: function () {},
  methods: {
    changeTimer: function() {
      this.data.breatheInTime = 8
    },
    changedAnimation: function(animType) {
      this.$refs.sketch.stopSketch()
      this.animationType = animType
    },
    changedSound: function(soundType) {
      this.data.playSound = soundType
    },
    enterFullscreen: function () {
      var elem = document.getElementById("timer-box");
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari & Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen();
      }
    },
  },
};
</script>

<style>
/* nunito-regular - latin */
@font-face {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url("https://mindfuldevmag.com/fonts/nunito-v12-latin-regular.eot");
  /* IE9 Compat Modes */
  src: local("Nunito Regular"), local("Nunito-Regular"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-regular.eot?#iefix")
      format("embedded-opentype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-regular.woff2")
      format("woff2"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-regular.woff")
      format("woff"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-regular.ttf")
      format("truetype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-regular.svg#Nunito")
      format("svg");
  /* Legacy iOS */
}

/* nunito-italic - latin */
@font-face {
  font-family: "Nunito";
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  src: url("https://mindfuldevmag.com/fonts/nunito-v12-latin-italic.eot");
  /* IE9 Compat Modes */
  src: local("Nunito Italic"), local("Nunito-Italic"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-italic.eot?#iefix")
      format("embedded-opentype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-italic.woff2")
      format("woff2"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-italic.woff")
      format("woff"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-italic.ttf")
      format("truetype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-italic.svg#Nunito")
      format("svg");
  /* Legacy iOS */
}

/* nunito-700 - latin */
@font-face {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700.eot");
  /* IE9 Compat Modes */
  src: local("Nunito Bold"), local("Nunito-Bold"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700.eot?#iefix")
      format("embedded-opentype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700.woff2")
      format("woff2"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700.woff")
      format("woff"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700.ttf")
      format("truetype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700.svg#Nunito")
      format("svg");
  /* Legacy iOS */
}

/* nunito-700italic - latin */
@font-face {
  font-family: "Nunito";
  font-style: italic;
  font-weight: 700;
  font-display: swap;
  src: url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700italic.eot");
  /* IE9 Compat Modes */
  src: local("Nunito Bold Italic"), local("Nunito-BoldItalic"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700italic.eot?#iefix")
      format("embedded-opentype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700italic.woff2")
      format("woff2"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700italic.woff")
      format("woff"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700italic.ttf")
      format("truetype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-700italic.svg#Nunito")
      format("svg");
  /* Legacy iOS */
}

@font-face {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url("https://mindfuldevmag.com/fonts/nunito-v12-latin-600.eot");
  /* IE9 Compat Modes */
  src: local("Nunito SemiBold"), local("Nunito-SemiBold"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-600.eot?#iefix")
      format("embedded-opentype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-600.woff2")
      format("woff2"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-600.woff")
      format("woff"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-600.ttf")
      format("truetype"),
    url("https://mindfuldevmag.com/fonts/nunito-v12-latin-600.svg#Nunito")
      format("svg");
  /* Legacy iOS */
}
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  background: #464646;
  color: #dcdccc;
  font-family: "Nunito", sans-serif;
}

.timer-box {
  position: relative;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

h1 {
  font-weight: 700;
  margin-bottom: 10px;
  margin-top: 40px;
}

footer {
  text-align: center;
  vertical-align: middle;
  padding: 10px;
}
footer img {
  height: 40px;
  vertical-align: middle;
}

footer a,
footer small {
  color: #dcdccc;
}

a {
  color: #8faf9f;
  cursor: pointer;
}

.container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: auto;
  position: relative;
  padding: 0;
  height: 350px;
  width: 350px;;
}


@media only screen and (max-width: 350px) {

  footer img {
    height: 70%;
    vertical-align: middle;
  }
}

.teaser {
  font-size: 1.4rem;
}

</style>